<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }} "{{ model.name }}"</p>
      </header>
      <section class="modal-card-body">
        <!-- <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field> -->
        <b-field label="Locale" v-if="id">
          <b-input placeholder="Locale" disabled v-model="model.name"></b-input>
        </b-field>
        <b-field
          label="Название сайта">
          <b-input
            name="site_name"
            placeholder="Название сайта"
            v-validate="'required'"
            v-model="model.site_name">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка обучения">
          <b-input
            name="intro"
            placeholder="Кнопка обучения"
            v-validate="'required'"
            v-model="model.intro">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка смены вида карты">
          <b-input
            name="map_action"
            placeholder="Кнопка смены вида карты"
            v-validate="'required'"
            v-model="model.map_action">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка карзины">
          <b-input
            name="cart"
            placeholder="Кнопка карзины"
            v-validate="'required'"
            v-model="model.cart">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка регистрации">
          <b-input
            name="signup"
            placeholder="Кнопка регистрации"
            v-validate="'required'"
            v-model="model.signup">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка входа">
          <b-input
            name="signin"
            placeholder="Кнопка входа"
            v-validate="'required'"
            v-model="model.signin">
          </b-input>
        </b-field>
        <b-field
          label="Кнопка выхода">
          <b-input
            name="logout"
            placeholder="Кнопка выхода"
            v-validate="'required'"
            v-model="model.logout">
          </b-input>
        </b-field>
        <b-field
          label="Поле поиска ЭНК">
          <b-input
            name="search"
            placeholder="Поле поиска ЭНК"
            v-validate="'required'"
            v-model="model.search">
          </b-input>
        </b-field>
        <b-field
          label="Фильтр масштабов">
          <b-input
            name="filters"
            placeholder="Фильтр масштабов"
            v-validate="'required'"
            v-model="model.filters">
          </b-input>
        </b-field>
        <b-field
          label="Панель инструментов">
          <b-input
            name="toolbar"
            placeholder="Панель инструментов"
            v-validate="'required'"
            v-model="model.toolbar">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: отдалить">
          <b-input
            name="zoom_in"
            placeholder="Инструмент: отдалить"
            v-validate="'required'"
            v-model="model.zoom_in">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: приблизить">
          <b-input
            name="zoom_out"
            placeholder="Инструмент: приблизить"
            v-validate="'required'"
            v-model="model.zoom_out">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: ручной режим">
          <b-input
            name="hand_mode"
            placeholder="Инструмент: ручной режим"
            v-validate="'required'"
            v-model="model.hand_mode">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: добавление по клику">
          <b-input
            name="add_on_click"
            placeholder="Инструмент: добавление по клику"
            v-validate="'required'"
            v-model="model.add_on_click">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: удаление по клику">
          <b-input
            name="site_name"
            placeholder="Инструмент: удаление по клику"
            v-validate="'required'"
            v-model="model.site_name">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: добавление областью">
          <b-input
            name="add_on_select"
            placeholder="Инструмент: добавление областью"
            v-validate="'required'"
            v-model="model.add_on_select">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: удаление областью">
          <b-input
            name="rem_on_select"
            placeholder="Инструмент: удаление областью"
            v-validate="'required'"
            v-model="model.rem_on_select">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: добавление маршрутом">
          <b-input
            name="add_on_route"
            placeholder="Инструмент: добавление маршрутом"
            v-validate="'required'"
            v-model="model.add_on_route">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: удаление маршрутом">
          <b-input
            name="rem_on_route"
            placeholder="Инструмент: удаление маршрутом"
            v-validate="'required'"
            v-model="model.rem_on_route">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: очистить корзину">
          <b-input
            name="clear_cart"
            placeholder="Инструмент: очистить корзину"
            v-validate="'required'"
            v-model="model.clear_cart">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: оформить заказ">
          <b-input
            name="checkout"
            placeholder="Инструмент: оформить заказ"
            v-validate="'required'"
            v-model="model.checkout">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: просмотр всей карты">
          <b-input
            name="map_world"
            placeholder="Инструмент: просмотр всей карты"
            v-validate="'required'"
            v-model="model.map_world">
          </b-input>
        </b-field>
        <b-field
          label="Инструмент: просмотр заказа на карте">
          <b-input
            name="map_order"
            placeholder="Инструмент: просмотр заказа на карте"
            v-validate="'required'"
            v-model="model.map_order">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'LocaleForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      confirmPassword: '',
      model: {
        id: undefined,
        name: '',
        site_name: ''
      },
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getLocale', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = {}
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateLocale', $this.model)
      }
      // else{
      //   $this.$store.dispatch('createCategory', $this.model)
      // }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>